const handlePriceSammaryOpen = ()=>{
   document.querySelector(".price-summary-wrapper").classList.toggle("open");
   document.querySelector(".calculation-of-saving").classList.toggle("open");
   document.querySelector(".congo-msg").classList.toggle("open");
}

const handleInputChange = (e)=> {
  const aplBtn =document.getElementById("apply_with_btn")
  aplBtn.disabled = e.target.value.trim() === "";
}

const discountModalopen = async ()=>{
   document.querySelector(".discount-modal").classList.add("open-offer");
   
       
             
}
const discountModalclose = ()=>{
   document.querySelector(".discount-modal").classList.remove("open-offer");
}

// for gift modal
function hadleModelOpen(ref_class){
    element = document.getElementsByClassName(ref_class)[0]
    if(element){
        element.classList.remove("d-none")
    }
}
function handleModelClose(ref_class){
    element = document.getElementsByClassName(ref_class)[0]
    if(element){
        element.classList.add("d-none")
    }
    
}
async function reloadActionButton(productId) {

    const wrapper = document.getElementById(`actionbtnloader-${productId}`);

    if (!wrapper) return;

    const response = await fetch(window.location.pathname);
    const html = await response.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const newWrapper = doc.getElementById(`actionbtnloader-${productId}`);

    if (newWrapper) {
        wrapper.innerHTML = newWrapper.innerHTML;
    }
}


async function handleCustomcartAdd(variantId, productId ,giftProductIds , numberOfGift) {
    const addBtn = document.getElementById(`add-btn-${productId}`);
    if (addBtn.disabled) return;
    addBtn.disabled = true;
    if( giftProductIds > 1 ||  numberOfGift > 1){
        const cart = await fetch('/cart.js').then(res => res.json());
            let giftCount = 0;
            cart.items.forEach(item => {
                if (giftProductIds.includes(item.product_id)) {
                giftCount++;
                }
        });

        const alreadyInCart = cart.items.some(
            item => item.product_id == productId
        );

        if (giftCount >= numberOfGift && !alreadyInCart) {
            const msg = document.querySelector('.maximum-gift-msg');
            msg.classList.remove('d-none');
            setTimeout(() => {
              msg.classList.add('d-none');
            }, 2000);
            return;
        }
     }
     try {
        document.querySelector('.gift-loader').classList.remove('d-none');
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });
  } finally {
    await reloadActionButton(productId);
    document.querySelector('.gift-loader').classList.add('d-none');
    addBtn.disabled = false;
    // const addBtn = document.getElementById(`add-btn-${productId}`);
    // const removeBtn = document.getElementById(`remove-btn-${productId}`);
    // addBtn?.classList.add('d-none');
    // removeBtn?.classList.remove('d-none');
    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        detail: {
          open: true,
          // onlyItems: true
        }
      })
    );
  }
    
}
async function handleCustomcartremove(variantId, productId ) {
  document.querySelector('.gift-loader').classList.remove('d-none');
  try{
      await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0
      })
    });
  } finally{
    await reloadActionButton(productId);
    document.querySelector('.gift-loader').classList.add('d-none');
    // const addBtn = document.getElementById(`add-btn-${productId}`);
    // const removeBtn = document.getElementById(`remove-btn-${productId}`);
    // removeBtn?.classList.add('d-none');
    // addBtn?.classList.remove('d-none');
    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        detail: {
          open: true,
          // onlyItems: true
        }
      })
    );
  }
 
}


let giftRemovalRunning = false;

function hideGiftImmediately(variantIds) {
  variantIds.forEach((variantId) => {

    // Quantity input based detection
    const inputs = document.querySelectorAll(
      `input[name="updates[]"][value="${variantId}"]`
    );

    inputs.forEach((input) => {
      const item =
        input.closest("m-cart-drawer-item") ||
        input.closest(".m-cart-item") ||
        input.closest(".m-cart-drawer__item") ||
        input.closest("li") ||
        input.parentElement?.parentElement;

      if (item) {
        item.style.display = "none";
      }
    });
    const variantElements = document.querySelectorAll(
      `[data-variant-id="${variantId}"]`
    );

    variantElements.forEach((element) => {
      const item =
        element.closest("m-cart-drawer-item") ||
        element.closest(".m-cart-item") ||
        element.closest(".m-cart-drawer__item") ||
        element.closest("li");

      if (item) {
        item.style.display = "none";
      }
    });
  });
}


async function removeGiftProductsIfThresholdNotMet(cart) {

  if (giftRemovalRunning) return;

  const updates = {};
  const giftVariantIds = [];

  if (cart.total_price < 599 * 100) {

    const item = cart.items.find(
      item => item.product_id == 8928575488213
    );

    if (item) {
      updates[item.variant_id] = 0;
      giftVariantIds.push(item.variant_id);
    }
  }

  if (cart.total_price < 799 * 100) {

    const item = cart.items.find(
      item => item.product_id == 8955773124821
    );

    if (item) {
      updates[item.variant_id] = 0;
      giftVariantIds.push(item.variant_id);
    }
  }

  if (cart.total_price < 999 * 100) {

    const item = cart.items.find(
      item => item.product_id == 8931033415893
    );

    if (item) {
      updates[item.variant_id] = 0;
      giftVariantIds.push(item.variant_id);
    }
  }

  // Nothing to remove
  if (Object.keys(updates).length === 0) {
    return;
  }

  hideGiftImmediately(giftVariantIds);

  giftRemovalRunning = true;

  try {

    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        updates: updates
      })
    });

    if (!response.ok) {
      throw new Error("Gift removal failed");
    }

    const cartDrawer = document.querySelector("m-cart-drawer");

    if (cartDrawer) {
      cartDrawer.onCartDrawerUpdate(true);
    }

  } catch (error) {

    console.error(
      "Free gift auto removal error:",
      error
    );

  } finally {

    giftRemovalRunning = false;

  }
}


document.addEventListener("cart:updated", async (event) => {

  if (!event.detail || !event.detail.cart) return;

  await removeGiftProductsIfThresholdNotMet(
    event.detail.cart
  );

});